export enum ELEMENT_IDS {
  LAYOUT = '__layout',
  MAIN_TEMPLATE = 'main-template',
  PAGE_CONTENT = 'page-content',
}
